import { useNavigate } from 'react-router-dom';

import { withErrorBoundary } from 'components/shared/Error/Boundary';
import Icon from 'components/shared/Icon/Icon';

const BackToMyPortal = () => {
  const navigate = useNavigate();
  const redirectToMyPortal = () => {
    navigate('/myportal/forms');
  };
  return (
    <div
      onClick={redirectToMyPortal}
      className="flex w-full cursor-pointer items-center gap-3 bg-neutral-100 p-4 text-primary-500 shadow-small">
      <Icon icon="chevron-left-linear" color="primary" />
      <span>Go to MyPortal</span>
    </div>
  );
};

export default withErrorBoundary(BackToMyPortal);
